import './verticalAccordionTwo.scss'
import React, { useLayoutEffect, useRef, useState } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { publicationData } from './publications/publicationData'
import VerticalAccordionItem from '../VerticalAccordionItem/verticalAccordionItem'
import { isMobile } from 'react-device-detect'

gsap.registerPlugin(ScrollTrigger)

let timeline = gsap.timeline({})

const VerticalAccordionItemTwo = () => {
    const tl = useRef(timeline)
    const [isItemOpen, setIsItemOpen] = useState(0)
    const component = useRef<HTMLDivElement>(null)
    const accordionItems = useRef(new Array())

    useLayoutEffect(() => {
        // Disable animation for screens <= 980px (matches SCSS breakpoint)
        if (window.innerWidth <= 980 || isMobile) return
        const ctx = gsap.context(() => {
            tl.current.to(accordionItems.current, {
                x: -100 * (accordionItems.current.length - 1),
                ease: 'none',
                scrollTrigger: {
                    trigger: component.current,
                    // Pin (and only then start the horizontal scrub) once the
                    // accordion reaches the top of the viewport, just below the
                    // 80px fixed navbar. Using a bare '-80px' offset made the
                    // scrub start as soon as the container entered the viewport
                    // bottom — i.e. while the video overlay was still on screen.
                    start: 'top 80px',
                    pin: true,
                    scrub: 0.6,
                    markers: false,
                    end: () => '+=' + component?.current?.offsetWidth,
                },
            })
        })

        return () => ctx.revert()
    }, [])

    function handleToggle(item: any, index: number) {
        if (isItemOpen === index) {
            return setIsItemOpen(0)
        }

        setIsItemOpen(index)
    }

    return (
        <div ref={component} id="container">
            {publicationData.map((publication: any, index: number) => {
                return (
                    <VerticalAccordionItem
                        ref={(element) =>
                            (accordionItems.current[index] = element)
                        }
                        // @ts-ignore
                        key={index}
                        index={index}
                        pdfLink={publication.pdfLink}
                        image={publication.image}
                        active={isItemOpen === index}
                        icon={publication.icon}
                        triggerTitle={publication.triggerTitle}
                        title={publication.title}
                        journal={publication.journal}
                        date={publication.date}
                        description={publication.description}
                        authors={publication.authors}
                        authorship={publication.authorship}
                        backgroundColor={publication.backgroundColor}
                        handleToggle={() => handleToggle(publication, index)}
                        // backgroundColor={backgroundColors[index]}
                    />
                )
            })}
        </div>
    )
}

export default VerticalAccordionItemTwo
